'use client'

import type { ReactNode } from 'react'

import { useStoryblokLivePreview } from '@/hooks/client/use-storyblok-live-preview'
import type { Locale } from '@/i18n'

interface Props {
  /** The server-rendered blok tree, shown until the editor's first keystroke. */
  initial: ReactNode
  storyblokId: number
  fullSlug: string
  locale: Locale
  segment: string
  token: string | null
}

export const DraftStoryLive = ({ initial, ...options }: Props) => {
  const live = useStoryblokLivePreview(options)
  return <>{live ?? initial}</>
}
